<template>
  <div class="page">
    <div class="page-title">{{ $t('VehicleExpenses.bigTitle') }}</div>
    <div class="table-header">
      <div class="table-header-title">{{ $t('VehicleExpenses.title1') }}</div>
      <div class="table-header-title">{{ $t('VehicleExpenses.title2') }}</div>
      <div class="table-header-title">{{ $t('VehicleExpenses.title3') }}</div>
    </div>
    <div class="table-content">
      <div class="table-content-box" style="border-left: 1px solid #BBB290">
        <div class="content-text">{{ $t('VehicleExpenses.type1.content1') }}</div>
        <div class="content-text">{{ $t('VehicleExpenses.type1.content2') }}</div>
        <div class="content-text">{{ $t('VehicleExpenses.type1.content3') }}</div>
        <div class="content-text">{{ $t('VehicleExpenses.type1.content4') }}</div>
        <div class="content-text" style="border-bottom: 0px">
          {{ $t('VehicleExpenses.type1.content5') }}
        </div>
      </div>
      <div class="table-content-box">
        <div class="content-text">{{ $t('VehicleExpenses.type2.content1') }}</div>
        <div class="content-text">{{ $t('VehicleExpenses.type2.content2') }}</div>
        <div class="content-text">{{ $t('VehicleExpenses.type2.content3') }}</div>
        <div class="content-text">{{ $t('VehicleExpenses.type2.content4') }}</div>
        <div class="content-text" style="border-bottom: 0px">
          {{ $t('VehicleExpenses.type2.content5') }}
        </div>
      </div>
      <div class="table-content-box">
        <div class="table-content-right">{{ $t('VehicleExpenses.type3.content1') }}</div>
        <div class="table-content-right">{{ $t('VehicleExpenses.type3.content2') }}</div>
        <div class="table-content-right">{{ $t('VehicleExpenses.type3.content3') }}</div>
        <div class="table-content-right">{{ $t('VehicleExpenses.type3.content4') }}</div>
        <div class="table-content-right">{{ $t('VehicleExpenses.type3.content5') }}</div>
        <div class="table-content-right">{{ $t('VehicleExpenses.type3.content6') }}</div>
        <div class="table-content-right">{{ $t('VehicleExpenses.type3.content7') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: []
    }
  },
  mounted() {},
  methods: {}
}
</script>
<style scoped lang="scss">
.page {
  width: 100%;
  background-color: $bg-color;
  padding: 86px 330px;
  box-sizing: border-box;
  .page-title {
    font-size: 36px;
    line-height: 70px;
    font-weight: 500;
    color: $light-color;
    //display: flex;
    //align-items: center;
    //justify-content: center;
    margin-bottom: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $primary-color;
    width: 1350px;
    .table-header-title {
      border-right: 1px solid $bg-color;
      //border: 1px solid $bg-color;
      width: 450px;
      color: $bg-color;
      font-size: 24px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 84px;
    }
  }
  .table-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1350px;
    background-color: $bg-color;
    border-bottom: 1px solid $primary-color;
    .table-content-box {
      height: 400px;
      color: $light-color;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      width: 450px;
      border-right: 1px solid $primary-color;
      .content-text {
        border-bottom: 1px solid $primary-color;
        height: 80px;
        padding: 20px;
        box-sizing: border-box;
      }
      .table-content-right {
        padding: 10px 20px;
        font-size: 18px;
      }
    }
  }
}
</style>
